import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Form,
  Input,
  Icon,
  Row,
  Col,
  Button,
  Select,
  Checkbox,
  Popconfirm
} from 'antd';
import styles from './AppStrategyItem.less';
import DateTimePicker from '../DateTimePicker';
import SyncModal from './SyncModal';
const FormItem = Form.Item;
const Option = Select.Option;
import moment from 'moment';

let uuid = 85412369;
@inject('appStrategyStore')
@observer
class AppStrategyItemComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      useTime: moment(),
      appListKey: [...this.props.data.app_list] || []
    };
    this.timeChange = this.timeChange.bind(this);
  }
  timeChange(value) {
    this.setState({
      useTime: value
    });
  }
  // componentDidMount() {
  //   const { data } = this.props;
  //   let appList = {};
  //   if (data['app_list'] && data['app_list'].length) {
  //     [...data['app_list']].map((item, index) => {
  //       appList[`appNames[${index}]`] = item.name;
  //       appList[`appVersions[${index}]`] = item.current_version;
  //       appList[`appStart[${index}]`] = false;
  //       uuid++;
  //     });
  //   }
  //   this.props.form.setFieldsValue(Object.assign({ ...appList }), {
  //     // useType: data.status == '计划中' ? '1' : '0',
  //     // useTime: data['plan_date'],
  //     // need_reboot: data['need_reboot'],
  //     // install_now: data['install_now']
  //   });
  //   this.props.form.setFieldsValue({ useType: data['plan_date'] ? '1' : '0' });
  //   this.props.form.setFieldsValue({ useTime: data['plan_date'] });
  //   this.props.form.setFieldsValue({ need_reboot: data['need_reboot'] });
  //   this.props.form.setFieldsValue({ install_now: data['install_now'] });
  // }

  remove = k => {
    this.setState({
      appListKey: [...this.state.appListKey].filter(key => key.id !== k.id)
    });
  };
  add = () => {
    const nextKeys = [...this.state.appListKey].concat([
      { id: uuid, name: '', current_version: '' }
    ]);
    this.setState({
      appListKey: nextKeys
    });
    uuid++;
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.useTime = moment(this.state.useTime);
        this.props.appStrategyStore.showSyncModal();
        this.props.appStrategyStore.currentStrategId = this.props.data.id;

        const form = new FormData();
        form.append('strategy_id', this.props.data.id);
        form.append('name', this.props.data.name);
        form.append('tag_id', (this.props.data.tag[0] || {}).id);
        form.append('need_reboot', values.need_reboot || false);
        form.append('install_now', values['install_now'] || false);
        form.append('check_version', false);
        let appList = (
          (values.appNames || []).filter(
            item => item !== undefined && item !== null
          ) || []
        ).map((item, index) => {
          const app = [...this.props.appListArr].filter(
            a => a['app_name'] === item
          );
          return {
            id: (app[0] || {})['app_id'],
            name: (app[0] || {})['app_name'],
            current_version: values.appVersions.filter(
              item => item !== undefined && item !== null
            )[index]
          };
        });
        this.props.appStrategyStore.SyncModalData = {
          useType: values.useType,
          useTime: values.useTime,
          appList: [...appList]
        };
        let appendList = [...appList].map(item => {
          delete item.name;
          return item;
        });
        form.append('app_list', JSON.stringify([...appendList] || []));
        this.props.appStrategyStore.AddAppStrategy(form);
      }
    });
  };

  handleSelectChange = key => {
    let obj = {};
    obj[`appVersions[${key}]`] = '';
    this.props.form.setFieldsValue({
      ...obj
    });
  };

  render() {
    const { data, appListArr } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      cancelStrategy,
      deleteAppStrategy,
      loadStrategyProgress
    } = this.props.appStrategyStore;
    let apps = [...appListArr] || [];
    const disabled =
      data.status == '计划中' || data.status == '已应用' || !data.tag.length;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
      }
    };
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 22, offset: 2 },
        sm: { span: 17, offset: 7 }
      }
    };
    const formItems = [...this.state.appListKey].map((k, index) => {
      let currentAppId = getFieldValue(`appNames[${k.id}]`);
      let currentAppObj =
        apps.find(app => app['app_name'] == currentAppId) || {};
      let versionOption = [...(currentAppObj.file_list || [])];
      return (
        <div key={index}>
          <Row>
            <Col span={7}>
              <FormItem
                {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                label={index === 0 ? '推送App' : ''}
                required={false}
                key={'name' + k.id}
              >
                {getFieldDecorator(`appNames[${k.id}]`, {
                  validateTrigger: ['onChange', 'onBlur'],
                  rules: [
                    {
                      required: true,
                      message: '请选择推送的App'
                    }
                  ],
                  initialValue: k.name || ''
                })(
                  <Select
                    placeholder="请选择推送的App"
                    style={{ marginRight: 8, width: '95%' }}
                    disabled={disabled}
                    onChange={() => this.handleSelectChange(k.id)}
                  >
                    {apps && apps.length
                      ? apps.map((app, index) => (
                          <Option key={index} value={app['app_name']}>
                            {app['app_name'] || '--'}
                          </Option>
                        ))
                      : ''}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem
                wrapperCol={{ span: 24 }}
                required={false}
                key={'version' + k.id}
              >
                {getFieldDecorator(`appVersions[${k.id}]`, {
                  initialValue: k.current_version || ''
                })(
                  <Select placeholder="选择版本" disabled={disabled}>
                    {[...versionOption] && [...versionOption].length
                      ? [...versionOption].map(a => (
                          <Option key={a.app_version} value={a.app_version}>
                            {a.app_version}
                          </Option>
                        ))
                      : null}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={7} offset={1}>
              <FormItem
                required={false}
                key={'boot' + k.id}
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 13 }}
              >
                {getFieldDecorator(`appStart[${k}]`, {
                  valuePropName: 'checked',
                  initialValue: true
                })(<Checkbox disabled={disabled}>设定为启动项</Checkbox>)}
                {[...this.state.appListKey].length >= 1 && !disabled ? (
                  <Icon
                    className="dynamic-delete-button"
                    type="minus-circle-o"
                    disabled={[...this.state.appListKey].length === 1}
                    onClick={() => this.remove(k)}
                  />
                ) : null}
              </FormItem>
            </Col>
          </Row>
        </div>
      );
    });
    return (
      <div className={styles.AppStrategyContainer}>
        <Row className={styles.rowContainer}>
          <Col span={4} className={styles.itemName}>
            {data.name || '--'}
          </Col>
          <Col offset={16} span={2}>
            <Button
              disabled={disabled}
              type={disabled ? '' : 'primary'}
              onClick={this.handleSubmit}
            >
              {data.status == '计划中'
                ? '延时应用'
                : data.status == '已应用' ? '已应用' : '同步应用'}
            </Button>
          </Col>
          <Col span={2}>
            {data.status === '已创建' || data.status == '计划中' ? (
              <Popconfirm
                title={`确定要${
                  data.status === '已创建' ? '删除' : '撤销'
                }该策略吗?`}
                okText="确定"
                cancelText="取消"
                onConfirm={
                  data.status === '已创建'
                    ? () => deleteAppStrategy(data.id)
                    : () => cancelStrategy(data.id)
                }
              >
                <Button>
                  {data.status === '已创建' ? '删除策略' : '撤销进度'}
                </Button>
              </Popconfirm>
            ) : (
              <Button onClick={() => loadStrategyProgress(data.id)}>
                查看进度
              </Button>
            )}
          </Col>
        </Row>
        <Row className={styles.rowContainer}>
          <Col>设备分组: &nbsp;{(data.tag[0] || {}).name || '--'}</Col>
        </Row>
        <Form onSubmit={this.handleSubmit}>
          <Row className={styles.useType}>
            <Col span={5}>
              <FormItem
                label="应用方式"
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
              >
                {getFieldDecorator('useType', {
                  rules: [{ required: true, message: '请选择应用方式' }],
                  initialValue: data['plan_date'] ? '1' : '0'
                })(
                  <Select placeholder="请选择应用方式" disabled={disabled}>
                    <Option value="0">立即应用</Option>
                    <Option value="1">延时应用</Option>
                  </Select>
                )}
              </FormItem>
            </Col>
            {getFieldValue('useType') === '1' && (
              <Col offset={1} span={8}>
                <FormItem
                  label="应用时间"
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                >
                  {getFieldDecorator('useTime', {
                    initialValue: data['plan_date']
                  })(
                    <DateTimePicker
                      defaultValue={
                        data['plan_date'] ? moment(data['plan_date']) : moment()
                      }
                      disabled={disabled}
                      onChange={this.timeChange}
                    />
                  )}
                </FormItem>
              </Col>
            )}
          </Row>
          {formItems}
          <FormItem
            label={
              [...this.state.appListKey] && [...this.state.appListKey].length
                ? ''
                : '推送App'
            }
            labelCol={{ span: 2 }}
            wrapperCol={{
              span: 10,
              offset:
                [...this.state.appListKey] && [...this.state.appListKey].length
                  ? 2
                  : 0
            }}
          >
            <Button
              type="dashed"
              onClick={this.add}
              disabled={disabled || this.state.appListKey.length > 0}
            >
              <Icon type="plus" /> 添加App
            </Button>
          </FormItem>
          <FormItem>
            {getFieldDecorator('need_reboot', {
              valuePropName: 'checked',
              initialValue: data['need_reboot']
            })(
              <Checkbox
                disabled={data.status == '已应用' || data.status == '计划中'}
                className={styles.updataCheckBox}
              >
                是否更新完重启设备
              </Checkbox>
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('install_now', {
              valuePropName: 'checked',
              initialValue: data['install_now']
            })(
              <Checkbox
                disabled={data.status == '已应用' || data.status == '计划中'}
                className={styles.updataCheckBox}
              >
                是否立即更新App
              </Checkbox>
            )}
          </FormItem>
        </Form>
      </div>
    );
  }
}

const AppStrategyItem = Form.create()(AppStrategyItemComp);
export default AppStrategyItem;



// WEBPACK FOOTER //
// ./src/components/AppStrategy/AppStrategyItem.js